import EmployerEdit from "./EmployerEdit";
import EmployersList from "./EmployersList";

export default {
  list: EmployersList,
  edit: EmployerEdit,
};
